/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ChangePasswordResponseModel { 
    succeeded?: boolean;
    message?: string;
    code?: string;
    resultData?: string;
}